document.addEventListener('DOMContentLoaded', function () {
  if (window.__yarnCartAddonInit) return;
  window.__yarnCartAddonInit = true;

  injectStyle();

  document.body.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-yarn-addon-trigger]');
    if (!trigger) return;

    var line = trigger.closest('[data-yarn-addon-line]');
    if (!line) return;

    if (line.querySelector('[data-yarn-addon-panel]')) {
      // Panelet er allerede åpent — la klikket lukke det i stedet
      line.querySelector('[data-yarn-addon-panel]').remove();
      trigger.classList.remove('is-open');
      return;
    }

    trigger.classList.add('is-open');
    openPanel(line);
  });

  function injectStyle() {
    if (document.getElementById('yarn-cart-addon-style')) return;
    var style = document.createElement('style');
    style.id = 'yarn-cart-addon-style';
    style.textContent = [
      '.cart__item__content{flex-wrap:wrap !important;}',

      '.cart__item__yarn-addon{margin-top:14px;padding-top:14px;',
      'border-top:1px dashed var(--of-card-border,rgba(224,112,63,0.18));',
      'flex-basis:100% !important;width:100% !important;order:10 !important;}',

      '.cart__item__add-yarn{',
      'display:inline-flex;align-items:center;gap:8px;',
      'font-family:inherit;font-size:13px;font-weight:600;',
      'padding:9px 16px 9px 12px;border-radius:999px;',
      'background:var(--of-accent-soft,rgba(224,112,63,0.1));',
      'border:1.5px solid transparent;',
      'color:var(--of-accent,#e0703f);cursor:pointer;',
      'transition:background .15s ease, color .15s ease, transform .08s ease;}',

      '.cart__item__add-yarn-icon{font-size:16px;line-height:1;}',

      '.cart__item__add-yarn:hover{',
      'background:var(--of-accent,#e0703f);color:#fff;}',

      '.cart__item__add-yarn:active{transform:scale(0.96);}',

      '.cart__item__add-yarn.is-open{',
      'background:var(--of-accent,#e0703f);color:#fff;',
      'border-radius:14px 14px 0 0;}',

      '.yarn-addon-panel{margin-top:0;padding:14px;',
      'border-radius:0 14px 14px 14px;',
      'background:var(--of-accent-soft,rgba(224,112,63,0.08));',
      'display:flex;flex-direction:column;gap:10px;}',
      '.yarn-addon-slot-row{display:flex;align-items:center;gap:8px;}',
      '.yarn-addon-slot-row img{width:32px;height:32px;object-fit:cover;border-radius:6px;flex-shrink:0;}',
      '.yarn-addon-slot-row select{flex:1;padding:6px 8px;border-radius:8px;',
      'border:1px solid rgba(224,112,63,0.25);font-size:13px;background:#fff;}',
      '.yarn-addon-slot-qty{font-size:12px;opacity:0.7;white-space:nowrap;}',
      '.yarn-addon-confirm{align-self:flex-start;font-size:13px;padding:8px 16px;',
      'border-radius:999px;border:none;background:var(--of-pink,#ec4899);color:#fff;',
      'cursor:pointer;font-weight:600;}',
      '.yarn-addon-confirm:disabled{opacity:0.5;cursor:not-allowed;}'
    ].join('');
    document.head.appendChild(style);
  }

  // ---- Fargeavstand (samme metode som brukt i fargeoppslags-regnearket) ----
  // Konverterer hex -> Lab, og beregner Delta-E (CIE76) mellom to farger.
  function hexToLab(hex) {
    if (!hex) return null;
    var clean = hex.replace('#', '');
    if (clean.length !== 6) return null;

    var r = parseInt(clean.substr(0, 2), 16) / 255;
    var g = parseInt(clean.substr(2, 2), 16) / 255;
    var b = parseInt(clean.substr(4, 2), 16) / 255;

    function lin(c) { return c <= 0.04045 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4); }
    r = lin(r); g = lin(g); b = lin(b);

    var x = (r * 0.4124 + g * 0.3576 + b * 0.1805) * 100;
    var y = (r * 0.2126 + g * 0.7152 + b * 0.0722) * 100;
    var z = (r * 0.0193 + g * 0.1192 + b * 0.9505) * 100;

    var xn = 95.047, yn = 100.0, zn = 108.883;
    function f(t) { return t > 0.008856 ? Math.pow(t, 1 / 3) : (7.787 * t + 16 / 116); }
    var fx = f(x / xn), fy = f(y / yn), fz = f(z / zn);

    return [116 * fy - 16, 500 * (fx - fy), 200 * (fy - fz)];
  }

  function deltaE(hex1, hex2) {
    var lab1 = hexToLab(hex1), lab2 = hexToLab(hex2);
    if (!lab1 || !lab2) return Infinity;
    return Math.sqrt(
      Math.pow(lab1[0] - lab2[0], 2) +
      Math.pow(lab1[1] - lab2[1], 2) +
      Math.pow(lab1[2] - lab2[2], 2)
    );
  }

  function getColorSlots(line) {
    var slots = [];

    try {
      var colorSkeins = JSON.parse(line.dataset.yarnColorSkeins || '[]');
      colorSkeins.forEach(function (qty, index) {
        var parsed = parseInt(qty, 10);
        if (parsed > 0) slots.push({ index: index, quantity: parsed });
      });
    } catch (e) {
      console.error('[cart-yarn-add] kunne ikke lese fargeslot', e);
    }

    if (!slots.length) {
      var total = parseInt(line.dataset.yarnSkeins, 10);
      slots.push({ index: 0, quantity: total > 0 ? total : 1 });
    }

    return slots;
  }

  function openPanel(line) {
    var productsEl = line.querySelector('[data-yarn-addon-products]');
    var products = [];
    try { products = JSON.parse(productsEl.textContent || '[]'); } catch (e) { products = []; }
    if (!products.length) return;

    var slots = getColorSlots(line);

    var defaultHexList = [];
    try { defaultHexList = JSON.parse(line.dataset.yarnDefaultHex || '[]'); } catch (e) { defaultHexList = []; }

    function findClosestByHex(hex) {
      if (!hex) return null;

      var candidates = products.filter(function (p) { return !!p.color_hex; });
      if (!candidates.length) return null; // ingen av variantene har fargedata i det hele tatt

      var best = null;
      var bestDelta = Infinity;
      candidates.forEach(function (p) {
        var d = deltaE(hex, p.color_hex);
        if (d < bestDelta) {
          bestDelta = d;
          best = p;
        }
      });

      return best;
    }

    var panel = document.createElement('div');
    panel.className = 'yarn-addon-panel';
    panel.setAttribute('data-yarn-addon-panel', '');

    slots.forEach(function (slot) {
      var row = document.createElement('div');
      row.className = 'yarn-addon-slot-row';

      var preferredHex = defaultHexList[slot.index];
      var closestMatch = findClosestByHex(preferredHex);
      var defaultProduct = closestMatch || products[slot.index] || products[0];

      var img = document.createElement('img');
      img.src = defaultProduct.image_url || '';
      row.appendChild(img);

      var select = document.createElement('select');
      select.dataset.slotSelect = '';
      products.forEach(function (p, i) {
        var opt = document.createElement('option');
        opt.value = p.variant_id;
        opt.textContent = p.title;

        var isDefault = closestMatch
          ? p.variant_id === closestMatch.variant_id
          : (i === slot.index || (slot.index >= products.length && i === 0));

        if (isDefault) opt.selected = true;
        select.appendChild(opt);
      });
      select.addEventListener('change', function () {
        var match = products.filter(function (p) { return String(p.variant_id) === select.value; })[0];
        if (match) img.src = match.image_url || '';
      });
      row.appendChild(select);

      var qtyLabel = document.createElement('span');
      qtyLabel.className = 'yarn-addon-slot-qty';
      qtyLabel.textContent = slot.quantity + ' stk';
      row.appendChild(qtyLabel);

      row.dataset.quantity = slot.quantity;
      panel.appendChild(row);
    });

    var confirmBtn = document.createElement('button');
    confirmBtn.type = 'button';
    confirmBtn.className = 'yarn-addon-confirm';
    confirmBtn.textContent = 'Bekreft og legg til';
    panel.appendChild(confirmBtn);

    var sectionTargets = getSectionTargets();

    confirmBtn.addEventListener('click', function () {
      confirmBtn.disabled = true;
      confirmBtn.textContent = 'Legger til …';

      var rows = panel.querySelectorAll('.yarn-addon-slot-row');
      var items = Array.from(rows).map(function (row) {
        return {
          id: parseInt(row.querySelector('select').value, 10),
          quantity: parseInt(row.dataset.quantity, 10),
        };
      });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items, sections: sectionTargets.map(function (t) { return t.id; }).join(',') }),
      })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        })
        .then(function (data) {
          confirmBtn.textContent = 'Lagt til! ✓';
          applyRenderedSections(data.sections);
          refreshCartCount();
          setTimeout(function () {
            panel.remove();
            var trig = line.querySelector('[data-yarn-addon-trigger]');
            if (trig) trig.classList.remove('is-open');
          }, 1200);
        })
        .catch(function (err) {
          console.error('[cart-yarn-add] kunne ikke legge til garn', err);
          confirmBtn.disabled = false;
          confirmBtn.textContent = 'Noe gikk galt, prøv igjen';
        });
    });

    line.appendChild(panel);
  }

  // Finn hvilke cart-seksjoner som faktisk er tilstede på siden akkurat nå
  // (handlekurv-side og/eller cart-drawer kan begge være i DOM-en samtidig).
  function getSectionTargets() {
    var targets = [];
    document.querySelectorAll('[data-section-type="cart"], [data-section-type="cart-drawer"]').forEach(function (el) {
      if (el.dataset.sectionId) {
        targets.push({ id: el.dataset.sectionId, type: el.dataset.sectionType });
      }
    });
    return targets;
  }

  // Bytt inn den ferske, server-rendrede HTML-en for hver seksjon,
  // slik at nye linjeobjekter (garnet) faktisk dukker opp uten reload.
  function applyRenderedSections(sections) {
    if (!sections) return;

    getSectionTargets().forEach(function (target) {
      var html = sections[target.id];
      if (!html) return;

      var current = document.querySelector(
        '[data-section-id="' + target.id + '"][data-section-type="' + target.type + '"]'
      );
      if (!current) return;

      var temp = document.createElement('div');
      temp.innerHTML = html.trim();
      var fresh = temp.querySelector(
        '[data-section-id="' + target.id + '"][data-section-type="' + target.type + '"]'
      ) || temp.firstElementChild;

      if (fresh) current.replaceWith(fresh);
    });
  }

  function refreshCartCount() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.setAttribute('data-cart-count', cart.item_count);
          el.textContent = cart.item_count;
        });
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
      })
      .catch(function () { /* stille feil */ });
  }
});